import "/myapp/app/tailwind.css?transform-only";export default "__VITE_CSS_URL__2f6d796170702f6170702f7461696c77696e642e6373733f7472616e73666f726d2d6f6e6c79__"